import Cookies from 'js-cookie';
import storage from 'src/api/localStorage';


const ONBOARDING_STRING = 'onboarding';

const getShouldShowOnboardingFromParams = (queryString) => {
  // eslint-disable-next-line compat/compat
  const urlParams = new URLSearchParams(queryString);

  if (!urlParams.get(ONBOARDING_STRING)) {
    return false;
  }
  const onboardingFromStorage = storage.getItem(ONBOARDING_STRING);
  const cookieAgreementsVersion = Cookies.get('gpc_v');
  if (!onboardingFromStorage && Boolean(cookieAgreementsVersion)) {
    storage.setItem(ONBOARDING_STRING, 1);
    return true;
  }
  return false;
};

export default getShouldShowOnboardingFromParams;
